module.exports = __webpack_public_path__ + "static/Ownership_Logo_White-27a7c425f0913f9646679900edac8488.svg";